import { Block } from 'slate';
import { MUTABLE_BLOCKS } from '../../../types/BlockTypes';
export default (function (editor) {
  var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : editor.value.startBlock;
  return Block.isBlock(block) && MUTABLE_BLOCKS.includes(block.type);
});